module.exports = ".modal-backdrop {\n  z-index: -1; }\n\n/**************Modal*************/\n\n.modal-open {\n  overflow: hidden; }\n\n.modal {\n  position: fixed;\n  top: 55px;\n  right: 0;\n  bottom: 0;\n  left: 0; }\n\n.ag-material .ag-ltr .ag-cell-no-focus {\n  border-right: 1px solid #d3d3d3; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/widgets/display-list/display-list.component.scss
// module id = ./src/app/shared/components/widgets/display-list/display-list.component.scss
// module chunks = main